/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==============================================================================
   BEFORE-CHECKOUT STEP  —  custom code, not part of the stock Warehouse theme
   ==============================================================================
   1. ROUTER. The Checkout button on the cart page (form.cart-recap) and in the
      cart drawer (form#mini-cart) goes to /pages/before-checkout instead of
      straight to Shopify's checkout. The form is saved first with
      /cart/update.js, so the order note and the Terms of Sale attributes
      (snippets/terms-acceptance.liquid) are kept exactly as before.
      If anything fails, or JavaScript is off, the button behaves as stock and
      goes straight to checkout, so a customer can never get stuck.

   2. SERVICE SYNC. Warranty handling service lines carry the hidden property
      _covers_variant. If the item they cover is removed or its quantity drops,
      the service line is trimmed to match. A service ticked in a product
      page's add-on list (which only carries _Add_on_for) is linked to that
      product's line first; a service line with nothing to cover is removed.
      Runs on load and after cart changes.

   To switch the step off: delete this block. Nothing else depends on it.
   ============================================================================== */
(function () {
  if (window.__otaBeforeCheckout) return;
  window.__otaBeforeCheckout = true;

  var root = (window.routes && window.routes.rootUrlWithoutSlash) || '';
  var STEP_URL = root + '/pages/before-checkout';
  var UPDATE_URL = root + '/cart/update.js';
  var CART_URL = root + '/cart.js';
  var routing = false;

  function isCartForm(form) {
    return form && form.tagName === 'FORM' &&
      (form.id === 'mini-cart' || (form.classList && form.classList.contains('cart-recap')));
  }

  function stampTerms(form) {
    var f = form.querySelectorAll('[data-terms-timestamp]');
    for (var i = 0; i < f.length; i++) f[i].value = new Date().toISOString();
  }

  function goToStep(form, btn) {
    if (routing) return;
    routing = true;
    stampTerms(form);

    var data = new FormData(form);
    data.delete('checkout');

    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: new URLSearchParams(data).toString()
    }).then(function () {
      window.location.href = STEP_URL;
    }).catch(function () {
      /* Could not save the cart: fall back to the stock checkout so the sale is not lost. */
      window.location.href = root + '/checkout';
    });
  }

  /* Click is the main path (some theme code submits the form with form.submit(),
     which never fires a submit event). Submit catches the Enter key. Both run
     in the capture phase so they act before the theme's own listeners. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || !isCartForm(btn.form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    goToStep(btn.form, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var btn = e.submitter;
    if (!isCartForm(form) || !btn || btn.name !== 'checkout') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    goToStep(form, btn);
  }, true);

  /* ---------- Service sync ---------- */
  var syncTimer = null;
  var syncing = false;

  var SERVICE_HANDLE = 'warranty-handling-service';

  function refreshCart() {
    if (window.theme && window.theme.pageType === 'cart') {
      window.location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  /* A service added from a product page's add-on list arrives with only
     _Add_on_for (the product title). Link it to the item it was added with,
     so it shows "Covers: ..." and is trimmed with that item later. A service
     line with no link at all (added on its own) has nothing to cover and is
     removed. Returns a promise that resolves true if anything changed. */
  function linkServices(cart) {
    var jobs = [];

    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (it.handle !== SERVICE_HANDLE || p._covers_variant) return;

      var parent = null;
      if (p._Add_on_for) {
        for (var i = 0; i < cart.items.length; i++) {
          var c = cart.items[i];
          if (c.handle !== SERVICE_HANDLE && c.product_title === p._Add_on_for) { parent = c; break; }
        }
      }

      jobs.push(parent
        ? { id: it.key, quantity: it.quantity, properties: { 'Covers': parent.title, '_covers_variant': String(parent.variant_id) } }
        : { id: it.key, quantity: 0 });
    });

    if (!jobs.length) return Promise.resolve(false);

    /* One change at a time: each change can re-key the remaining lines. */
    return jobs.reduce(function (chain, job) {
      return chain.then(function () {
        return fetch(root + '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(job)
        });
      });
    }, Promise.resolve()).then(function () { return true; });
  }

  function syncServices() {
    if (syncing) return;
    syncing = true;

    var getCart = function () {
      return fetch(CART_URL, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    };

    getCart()
      .then(function (cart) {
        return linkServices(cart).then(function (linked) {
          return linked ? getCart().then(function (c) { c.__linked = true; return c; }) : cart;
        });
      })
      .then(function (cart) {
        var units = {};      /* variant id -> units of the real item in the cart */
        var services = [];

        cart.items.forEach(function (it) {
          var cv = it.properties && it.properties._covers_variant;
          if (cv) services.push({ key: it.key, cv: String(cv), qty: it.quantity });
          else units[it.variant_id] = (units[it.variant_id] || 0) + it.quantity;
        });

        var updates = {};
        var changed = false;

        services.forEach(function (s) {
          var left = units[s.cv] || 0;
          var keep = Math.min(s.qty, left);
          units[s.cv] = left - keep;
          if (keep !== s.qty) { updates[s.key] = keep; changed = true; }
        });

        if (!changed) {
          if (cart.__linked) refreshCart();
          return;
        }

        return fetch(UPDATE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(refreshCart);
      })
      .catch(function () {})
      .then(function () { syncing = false; });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncServices, 400);
  }

  if (window.theme && window.theme.cartCount > 0) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleSync);
    else scheduleSync();
  }

  document.documentElement.addEventListener('cart:updated', scheduleSync);
  document.documentElement.addEventListener('product:added', scheduleSync);
})();
